import { useOptionalConsent } from "./ConsentContext";

export function ConsentTrigger({ className }: { className?: string }) {
  const consent = useOptionalConsent();
  return (
    <button
      type="button"
      onClick={() => consent?.openSettings()}
      className={
        className ??
        "text-primary-foreground/75 text-left transition-colors hover:text-brand-button"
      }
      disabled={!consent}
    >
      Cookie-Einstellungen
    </button>
  );
}
